import api from './api';
import { publicApi } from './api';

export interface Activity {
  id: number;
  title: string;
  activity_type_id: number;
  type?: { id: number; name: string; label: string };
  date: string;
  time: string;
  location: string;
  max_participants: number;
  participants_count: number;
  status: 'active' | 'ended';
  image: string | null;
  description: string;
  created_by: number;
}

export const activityService = {
  async list(params?: { status?: string; type_id?: number }) {
    const { data } = await publicApi.get<{ data: Activity[] }>('/activities', { params });
    return Array.isArray(data) ? data : (data.data || data);
  },

  async get(id: number) {
    const { data } = await publicApi.get<Activity>(`/activities/${id}`);
    return data;
  },

  async create(payload: Partial<Activity>) {
    const { data } = await api.post<Activity>('/activities', payload);
    return data;
  },

  async update(id: number, payload: Partial<Activity>) {
    const { data } = await api.put<Activity>(`/activities/${id}`, payload);
    return data;
  },

  async delete(id: number) {
    await api.delete(`/activities/${id}`);
  },
};
